import { render, staticRenderFns } from "./PropertiesSkeleton.vue?vue&type=template&id=d19e02fa&scoped=true"
import script from "./PropertiesSkeleton.vue?vue&type=script&lang=js"
export * from "./PropertiesSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSkeleton.vue?vue&type=style&index=0&id=d19e02fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19e02fa",
  null
  
)

export default component.exports